'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Utils


// Actions


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = require('recompose');

var _lodash = require('lodash');

var _createElementConnectionsSourceSpec = require('../createElementConnectionsSourceSpec');

var _createElementConnectionsSourceSpec2 = _interopRequireDefault(_createElementConnectionsSourceSpec);

var _connectionsActions = require('../connectionsActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultCollect = {
    getConnectionSourceId: function getConnectionSourceId(props) {
        return props.elementId || props.element.get('id');
    },
    getConnectionTargetIds: function getConnectionTargetIds(props) {
        return null;
    }
};

/**
 * Identifies a possible connection source.
 * It takes a "spec" (specification) that can implement some hooks into actions (such as move events) and allow
 * the sources to perform some of their own logic and perhaps dispatch some events.
 *
 * It also takes a "collecting" function which allows the connection source ID and the target IDs to be defined
 * by the source.
 * By default the source ID will be either the 'elementId' or the 'element.get('id')' from the props, but this
 * can be overridden by implementing the 'getConnectionSourceId(props)' method.
 *
 * The 'getConnectionTargetIds(props)' is required and defines the connection target IDs that this source is
 * connecting to.
 */

exports.default = function (customSpec, customCollect) {
    return function (DecoratedComponent) {
        var collect = _extends({}, defaultCollect, customCollect);

        var ElementConnectionSource = function (_React$Component) {
            _inherits(ElementConnectionSource, _React$Component);

            function ElementConnectionSource(props, context) {
                _classCallCheck(this, ElementConnectionSource);

                var _this = _possibleConstructorReturn(this, (ElementConnectionSource.__proto__ || Object.getPrototypeOf(ElementConnectionSource)).call(this, props, context));

                _initialiseProps.call(_this);

                _this.manager = context.elementConnectionsManager;
                _this.connections = null;

                var id = collect.getConnectionSourceId(_this.props);

                _this.sourceSpec = (0, _createElementConnectionsSourceSpec2.default)(customSpec, props);
                _this.manager.registry.addSource(id, _this.sourceSpec);
                return _this;
            }

            _createClass(ElementConnectionSource, [{
                key: 'componentWillMount',
                value: function componentWillMount() {
                    this.propsChange(this.props);
                }
            }, {
                key: 'componentWillReceiveProps',
                value: function componentWillReceiveProps(nextProps) {
                    this.propsChange(nextProps);
                }
            }, {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    var id = collect.getConnectionSourceId(this.props);
                    this.manager.store.dispatch((0, _connectionsActions.connectionsRemove)({ id: id }));
                    this.manager.registry.removeSource(id);
                }
            }, {
                key: 'render',
                value: function render() {
                    return _react2.default.createElement(DecoratedComponent, this.props);
                }
            }]);

            return ElementConnectionSource;
        }(_react2.default.Component);

        var _initialiseProps = function _initialiseProps() {
            var _this2 = this;

            this.propsChange = function (props) {
                var id = collect.getConnectionSourceId(props);
                var connections = collect.getConnectionTargetIds(props);

                if (connections === _this2.connections || (0, _lodash.isEmpty)(connections) && (0, _lodash.isEmpty)(_this2.connections) || (0, _recompose.shallowEqual)(connections, _this2.connections)) return;

                _this2.sourceSpec.receiveProps(props);
                _this2.connections = connections;
                _this2.manager.store.dispatch((0, _connectionsActions.connectionsSet)({ id: id, connections: _this2.connections }));
            };
        };

        ElementConnectionSource.propTypes = {};

        ElementConnectionSource.contextTypes = {
            elementConnectionsManager: _propTypes2.default.object.isRequired
        };

        return ElementConnectionSource;
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/connections/components/elementConnectionsSourceDecorator.js
// module id = 1707
// module chunks = 0